import { render, staticRenderFns } from "./AddNewProductForm.vue?vue&type=template&id=18050e41&scoped=true&"
import script from "./AddNewProductForm.vue?vue&type=script&lang=js&"
export * from "./AddNewProductForm.vue?vue&type=script&lang=js&"
import style0 from "./AddNewProductForm.vue?vue&type=style&index=0&id=18050e41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18050e41",
  null
  
)

export default component.exports